module.exports = __webpack_public_path__ + "img/CM-KT-24-Mazda-Lifestyle.b78ac830.jpg";